import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d46538c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-code-generator" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "QR Code Generator", -1))
const _hoisted_3 = {
  key: 0,
  class: "qr-image-container"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.qrText) = $event)),
      placeholder: "Enter text or URL",
      class: "w-[70%] p-2.5 mb-4 mr-4 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
    }, null, 512), [
      [_vModelText, _ctx.qrText]
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateQR && _ctx.generateQR(...args))),
      class: "qr-btn"
    }, "Generate QR Code"),
    (_ctx.qrCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.qrCode,
            alt: "QR Code",
            class: "qr-image"
          }, null, 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true)
  ]))
}